import { defineAsyncComponent } from '@vue/composition-api';

const configuration = {
  'component-switcher': {
    component: defineAsyncComponent(() =>
      import(
        /* webpackChunkName: 'component-switcher' */
        '@/components/Configurator/ComponentSwitcher.vue'
      )
    )
  },

  'component-loader': {
    component: defineAsyncComponent(() =>
      import(
        /* webpackChunkName: 'component-loader' */
        '@/blocks/ComponentLoader/ComponentLoader.vue'
      )
    )
  },

  'block-reinsurance': {
    component: defineAsyncComponent(() =>
      import(
        /* webpackChunkName: 'reinsurance' */
        '@/blocks/Reinsurance/Reinsurance.vue'
      )
    ),
    config: () =>
      import(
        /* webpackChunkName: 'reinsurance-config' */
        '@/blocks/Reinsurance/config'
      )
  },

  'block-advantages': {
    component: defineAsyncComponent(() =>
      import(
        /* webpackChunkName: 'advantages' */
        '@/blocks/Advantages/Advantages.vue'
      )
    ),
    config: () =>
      import(
        /* webpackChunkName: 'advantages-config' */
        '@/blocks/Advantages/config'
      )
  },

  'block-services': {
    component: defineAsyncComponent(() =>
      import(
        /* webpackChunkName: 'services' */
        '@/blocks/Services/Services.vue'
      )
    ),
    config: () =>
      import(
        /* webpackChunkName: 'services-config' */
        '@/blocks/Services/config'
      )
  },

  'block-pack-header': {
    component: defineAsyncComponent(() =>
      import(
        /* webpackChunkName: 'pack-header' */
        '@/blocks/Headers/PackHeader/PackHeader.vue'
      )
    ),
    config: () =>
      import(
        /* webpackChunkName: 'pack-header-config' */
        '@/blocks/Headers/PackHeader/config'
      )
  },

  'block-simple-selector': {
    component: defineAsyncComponent(() =>
      import(
        /* webpackChunkName: 'simple-selector' */
        '@/blocks/CoffeeSelector/SimpleSelector.vue'
      )
    ),
    config: () =>
      import(
        /* webpackChunkName: 'simple-selector-config' */
        '@/blocks/CoffeeSelector/config'
      )
  },

  'block-heading': {
    component: defineAsyncComponent(
      () =>
        import(
          /* webpackChunkName: 'heading-block' */
          '@/blocks/ContentZone/Text/Heading/HeadingBlock.vue'
        )
    ),
  },

  'block-text': {
    component: defineAsyncComponent(
      () =>
        import(
          /* webpackChunkName: 'text-block' */
          '@/blocks/ContentZone/Text/Text/TextBlock.vue'
        )
    ),
  },

  'block-bullet-list': {
    component: defineAsyncComponent(
      () =>
        import(
          /* webpackChunkName: 'bullet-list-block' */
          '@/blocks/ContentZone/Text/BulletList/BulletListBlock.vue'
        )
    ),
  },

  'block-quote': {
    component: defineAsyncComponent(
      () =>
        import(
          /* webpackChunkName: 'block-quote' */
          '@/blocks/ContentZone/Text/Quote/QuoteBlockWrapper.vue'
        )
    ),
  },

  'block-spacer': {
    component: defineAsyncComponent(
      () =>
        import(
          /* webpackChunkName: 'block-spacer' */
          '@/blocks/ContentZone/Text/Spacer/SpacerBlock.vue'
       )
    ),
  },

  'block-layout': {
    component: defineAsyncComponent(
      () =>
        import(
          /* webpackChunkName: 'block-layout' */
          '@/blocks/ContentZone/Text/Layout/LayoutBlock.vue'
        )
    ),
  },

  'block-cta': {
    component: defineAsyncComponent(
      () =>
        import(
          /* webpackChunkName: 'block-cta' */
          '@/blocks/ContentZone/Cta/CtaBlockWrapper.vue'
        )
    ),
  },

  'block-visual': {
    component: defineAsyncComponent(
      () =>
        import(
          /* webpackChunkName: 'block-visual' */
          '@/blocks/ContentZone/Visual/VisualBlock.vue'
        )
    ),
  },

  'block-video': {
    component: defineAsyncComponent(
      () =>
        import(
          /* webpackChunkName: 'block-video' */
          '@/blocks/ContentZone/Video/VideoBlock.vue'
        )
    ),
  },

  'block-header': {
    component: defineAsyncComponent(
      () =>
        import(
          /* webpackChunkName: 'block-header' */
          '@/blocks/ContentZone/Header/HeaderBlock.vue'
        )
    ),
  },

  'block-header-zoom-out': {
    component: defineAsyncComponent(
      () =>
        import(
          /* webpackChunkName: 'block-header-zoom-out' */
          '@/blocks/ContentZone/Header/HeaderBlockZoomOut.vue'
        )
    ),
  },

  'block-push': {
    component: defineAsyncComponent(
      () =>
        import(
          /* webpackChunkName: 'block-push' */
          '@/blocks/ContentZone/Push/PushBlock/PushBlockWrapper.vue'
        )
    ),
  },

  'block-tag': {
    component: defineAsyncComponent(
      () =>
        import(
          /* webpackChunkName: 'block-tag' */
          '@/blocks/ContentZone/Tag/TagBlock.vue'
        )
    ),
  },

  'block-push-layout': {
    component: defineAsyncComponent(
      () =>
        import(
          /* webpackChunkName: 'block-push-layout' */
          '@/blocks/ContentZone/Push/PushLayout/PushLayoutBlock.vue'
        )
    ),
  },

  'block-push-content': {
    component: defineAsyncComponent(
      () =>
        import(
          /* webpackChunkName: 'block-push-content' */
          '@/blocks/ContentZone/Push/PushContent/PushContentBlockWrapper.vue'
        )
    ),
  },

  'block-push-content-selector': {
    component: defineAsyncComponent(
      () =>
        import(
          /* webpackChunkName: 'block-push-content' */
          '@/blocks/ContentZone/Push/PushContentSelector/PushContentSelectorBlock.vue'
        )
    ),
  },

  'block-push-visual-picto': {
    component: defineAsyncComponent(
      () =>
        import(
          /* webpackChunkName: 'block-push-visual-picto' */
          '@/blocks/ContentZone/Push/PushVisualPicto/PushVisualPictoBlock.vue'
        )
    ),
  },

  'block-cross-sell-slider': {
    component: defineAsyncComponent(
      () =>
        import(
          /* webpackChunkName: 'block-cross-sell-slider' */
          '@/blocks/ContentZone/CrossSell/CrossSellSlider/CrossSellSlider.vue'
        )
    ),
  },

  'block-cross-sell-slider-three': {
    component: defineAsyncComponent(
      () =>
        import(
          /* webpackChunkName: 'block-cross-sell-slider-three' */
          '@/blocks/ContentZone/CrossSell/CrossSellSlider/CrossSellSliderThree.vue'
        )
    ),
  },

  'block-cross-sell-one': {
    component: defineAsyncComponent(
      () =>
        import(
          /* webpackChunkName: 'block-cross-sell-one' */
          '@/blocks/ContentZone/CrossSell/CrossSellOne/CrossSellOne.vue'
        )
    ),
  },

  'block-cross-sell-one-machine': {
    component: defineAsyncComponent(
      () =>
        import(
          /* webpackChunkName: 'block-cross-sell-one-machine' */
          '@/blocks/ContentZone/CrossSell/CrossSellOneMachine/CrossSellOneMachine.vue'
        )
    ),
  },

  'block-cross-sell-product': {
    component: defineAsyncComponent(
      () =>
        import(
          /* webpackChunkName: 'block-cross-sell-product' */
          '@/blocks/ContentZone/CrossSell/CrossSellProduct/CrossSellProduct.vue'
        )
    ),
  },

  'block-cross-sell-two-product': {
    component: defineAsyncComponent(
      () =>
        import(
          /* webpackChunkName: 'block-cross-sell-two-product' */
          '@/blocks/ContentZone/CrossSell/CrossSellTwoProduct/CrossSellTwoProduct.vue'
        )
    ),
  },

  'block-assortment': {
    component: defineAsyncComponent(
      () =>
        import(
          /* webpackChunkName: 'block-assortment' */
          '@/blocks/ContentZone/Assortment/Assortment.vue'
        )
    ),
  },

  'block-cross-sell-two': {
    component: defineAsyncComponent(
      () =>
        import(
          /* webpackChunkName: 'block-cross-sell-two' */
          '@/blocks/ContentZone/CrossSell/CrossSellTwo/CrossSellTwo.vue'
        )
    ),
  },

  'block-push-side': {
    component: defineAsyncComponent(
      () =>
        import(
          /* webpackChunkName: 'block-push-side' */
          '@/blocks/ContentZone/Push/PushSide/PushSideBlock.vue'
        )
    ),
  },

  'block-visual-quote': {
    component: defineAsyncComponent(
      () =>
        import(
          /* webpackChunkName: 'block-visual-quote' */
          '@/blocks/ContentZone/VisualBlockQuote/VisualBlockQuote.vue'
        )
    ),
  },

  'block-pictos': {
    component: defineAsyncComponent(
      () =>
        import(
          /* webpackChunkName: 'block-picto' */
          '@/blocks/ContentZone/Pictos/PictoBlockWrapper.vue'
        )
    ),
  },

  'block-faq': {
    component: defineAsyncComponent(
      () =>
        import(
          /* webpackChunkName: 'block-faq' */
          '@/blocks/ContentZone/Faq/FaqBlockWrapper.vue'
        )
    ),
  },

  'block-caps-list': {
    component: defineAsyncComponent(
      () =>
        import(
          /* webpackChunkName: 'block-caps-list' */
          '@/blocks/CapsList/CapsListBlock.vue'
        )
    ),
  },

  'block-grid-coffee-selector': {
    component: defineAsyncComponent(
      () =>
        import(
          /* webpackChunkName: 'block-grid-coffee-selector' */
          '@/blocks/CapsList/GridCoffeeSelector.vue'
        )
    ),
  },

  'block-push-parallax': {
    component: defineAsyncComponent(
      () =>
        import(
          /* webpackChunkName: 'block-push-parallax' */
          '@/blocks/ContentZone/Push/PushBlockParallax/PushBlockWrapper.vue'
        )
    ),
  },

  'block-header-pop': {
    component: defineAsyncComponent(
      () =>
        import(
          /* webpackChunkName: 'block-header-pop' */
          '@/blocks/ContentZone/Header/HeaderPop/HeaderPopBlock.vue'
        )
    ),
  },

  'block-header-herme': {
    component: defineAsyncComponent(
      () =>
        import(
          /* webpackChunkName: 'block-header-herme' */
          '@/blocks/ContentZone/Header/HeaderPierreHerme/HeaderPierreHerme.vue'
        )
    ),
  },

  'block-header-sides': {
    component: defineAsyncComponent(
      () =>
        import(
          /* webpackChunkName: 'block-header-sides' */
          '@/blocks/ContentZone/Header/HeaderSides/HeaderSides.vue'
        )
    ),
  },

  'block-caps-row': {
    component: defineAsyncComponent(
      () =>
        import(
          /* webpackChunkName: 'block-caps-row' */
          '@/blocks/CapsRow/CapsRow.vue'
        )
    ),
  },

  'block-line': {
    component: defineAsyncComponent(
      () =>
        import(
          /* webpackChunkName: 'block-line' */
          '@/blocks/ContentZone/Text/Line/LineBlock.vue'
        )
    ),
  },

  /** Templates **/

  'template-default': {
    component: defineAsyncComponent(() =>
      import(
        /* webpackChunkName: 'template-default' */
        '@/blocks/Templates/TemplateDefault/TemplateDefault.vue'
      )
    )
  },

  'template-simple-header': {
    component: defineAsyncComponent(() =>
      import(
        /* webpackChunkName: 'template-simple-header' */
        '@/blocks/Templates/TemplateSimpleHeader/TemplateSimpleHeader.vue'
      )
    )
  },

  'template-simple-header-horizontal': {
    component: defineAsyncComponent(() =>
      import(
        /* webpackChunkName: 'template-simple-header-horizontal' */
        '@/blocks/Templates/TemplateSimpleHeaderHorizontal/TemplateSimpleHeaderHorizontal.vue'
      )
    )
  },

  'template-simple-header-vertical': {
    component: defineAsyncComponent(() =>
      import(
        /* webpackChunkName: 'template-simple-header-vertical' */
        '@/blocks/Templates/TemplateSimpleHeaderVertical/TemplateSimpleHeaderVertical.vue'
      )
    )
  },

  'template-assortment': {
    component: defineAsyncComponent(() =>
      import(
        /* webpackChunkName: 'template-assortment' */
        '@/blocks/Templates/TemplateAssortment/TemplateAssortment.vue'
      )
    )
  },

  'template-machine': {
    component: defineAsyncComponent(() =>
      import(
        /* webpackChunkName: 'template-machine' */
        '@/blocks/Templates/TemplateMachine/TemplateMachine.vue'
      )
    )
  },

  /** Démos **/

  'demo-assortment': {
    component: defineAsyncComponent(() =>
      import(
        /* webpackChunkName: 'demo-assortment' */
        '@/demos/Assortment/Assortment.vue'
      )
    ),
    config: () =>
      import(
        /* webpackChunkName: 'demo-assortment-config' */
        '@/demos/Assortment/Assortment.config'
      )
  },

  'demo-double-default': {
    component: defineAsyncComponent(() =>
      import(
        /* webpackChunkName: 'demo-double-default' */
        '@/demos/DoubleDefault/DoubleDefault.vue'
      )
    ),
    config: () =>
      import(
        /* webpackChunkName: 'demo-double-default-config' */
        '@/demos/DoubleDefault/DoubleDefault.config'
      )
  },

  'demo-single-default': {
    component: defineAsyncComponent(() =>
      import(
        /* webpackChunkName: 'demo-single-default' */
        '@/demos/SingleDefault/SingleDefault.vue'
      )
    ),
    config: () =>
      import(
        /* webpackChunkName: 'demo-single-default-config' */
        '@/demos/SingleDefault/SingleDefault.config'
      )
  },

  'demo-double': {
    component: defineAsyncComponent(() =>
      import(
        /* webpackChunkName: 'demo-double' */
        '@/demos/Double/Double.vue'
      )
    ),
    config: () =>
      import(
        /* webpackChunkName: 'demo-double-config' */
        '@/demos/Double/Double.config'
      )
  },

  'demo-double-product-duo-popin': {
    component: defineAsyncComponent(() =>
      import(
        /* webpackChunkName: 'demo-double-product-duo-popin' */
        '@/demos/DoubleProductDuoPopin/DoubleProductDuoPopin.vue'
      )
    ),
    config: () =>
      import(
        /* webpackChunkName: 'demo-double-product-popin-duo-config' */
        '@/demos/DoubleProductDuoPopin/DoubleProductDuoPopin.config'
      )
  },

  'demo-double-box-popin': {
    component: defineAsyncComponent(() =>
      import(
        /* webpackChunkName: 'demo-double-box-popin' */
        '@/demos/DoubleBoxPopin/DoubleBoxPopin.vue'
      )
    ),
    config: () =>
      import(
        /* webpackChunkName: 'demo-double-box-popin-config' */
        '@/demos/DoubleBoxPopin/DoubleBoxPopin.config'
      )
  },

  'demo-single': {
    component: defineAsyncComponent(() =>
      import(
        /* webpackChunkName: 'demo-single' */
        '@/demos/Single/Single.vue'
      )
    ),
    config: () =>
      import(
        /* webpackChunkName: 'demo-single-config' */
        '@/demos/Single/Single.config'
      )
  },

  'demo-single-box-popin': {
    component: defineAsyncComponent(() =>
      import(
        /* webpackChunkName: 'demo-single-box-popin' */
        '@/demos/SingleBoxPopin/SingleBoxPopin.vue'
      )
    ),
    config: () =>
      import(
        /* webpackChunkName: 'demo-single-box-popin-config' */
        '@/demos/SingleBoxPopin/SingleBoxPopin.config'
      )
  },

  'demo-single-product-duo-popin': {
    component: defineAsyncComponent(() =>
      import(
        /* webpackChunkName: 'demo-single-product-duo-popin' */
        '@/demos/SingleProductDuoPopin/SingleProductDuoPopin.vue'
      )
    ),
    config: () =>
      import(
        /* webpackChunkName: 'demo-single-product-duo-popin-config' */
        '@/demos/SingleProductDuoPopin/SingleProductDuoPopin.config'
      )
  },

  'demo-single-content-popin': {
    component: defineAsyncComponent(() =>
      import(
        /* webpackChunkName: 'demo-single-content-popin' */
        '@/demos/SingleContentPopin/SingleContentPopin.vue'
      )
    ),
    config: () =>
      import(
        /* webpackChunkName: 'demo-single-content-popin-config' */
        '@/demos/SingleContentPopin/SingleContentPopin.config'
      )
  },

  'demo-double-content-popin': {
    component: defineAsyncComponent(() =>
      import(
        /* webpackChunkName: 'demo-double-content-popin' */
        '@/demos/DoubleContentPopin/DoubleContentPopin.vue'
      )
    ),
    config: () =>
      import(
        /* webpackChunkName: 'demo-double-content-popin-config' */
        '@/demos/DoubleContentPopin/DoubleContentPopin.config'
      )
  },

  'demo-single-horizontal': {
    component: defineAsyncComponent(() =>
      import(
        /* webpackChunkName: 'demo-single-horizontal' */
        '@/demos/SingleHorizontal/SingleHorizontal.vue'
      )
    ),
    config: () =>
      import(
        /* webpackChunkName: 'demo-single-horizontal-config' */
        '@/demos/SingleHorizontal/SingleHorizontal.config'
      )
  },

  'demo-double-horizontal': {
    component: defineAsyncComponent(() =>
      import(
        /* webpackChunkName: 'demo-double-horizontal' */
        '@/demos/DoubleHorizontal/DoubleHorizontal.vue'
      )
    ),
    config: () =>
      import(
        /* webpackChunkName: 'demo-double-horizontal-config' */
        '@/demos/DoubleHorizontal/DoubleHorizontal.config'
      )
  },

  'demo-single-vertical': {
    component: defineAsyncComponent(() =>
      import(
        /* webpackChunkName: 'demo-single-vertical' */
        '@/demos/SingleVertical/SingleVertical.vue'
      )
    ),
    config: () =>
      import(
        /* webpackChunkName: 'demo-single-vertical-config' */
        '@/demos/SingleVertical/SingleVertical.config'
      )
  },

  'demo-double-vertical': {
    component: defineAsyncComponent(() =>
      import(
        /* webpackChunkName: 'demo-double-vertical' */
        '@/demos/DoubleVertical/DoubleVertical.vue'
      )
    ),
    config: () =>
      import(
        /* webpackChunkName: 'demo-double-vertical-config' */
        '@/demos/DoubleVertical/DoubleVertical.config'
      )
  },

  'demo-machine': {
    component: defineAsyncComponent(() =>
      import(
        /* webpackChunkName: 'demo-machine' */
        '@/demos/Machine/Machine.vue'
      )
    ),
    config: () =>
      import(
        /* webpackChunkName: 'demo-machine-config' */
        '@/demos/Machine/Machine.config'
      )
  },
};

export default configuration;
